<template>
  <div
    role="alert"
    class="relative w-full rounded-lg border px-4 py-4 mt-4 text-sm grid grid-cols-[auto_1fr] gap-x-4 items-start"
    :class="[
      `bg-${variant}-50`,
      `border-${variant}-200`,
      `text-${variant}-800`
    ]"
  >
    <!-- Icon slot -->
    <slot name="icon">
    </slot>

    <!-- Title -->
    <div class="col-start-2 justify-items-start">
      <strong>{{ $t(title) }}</strong>
    </div>

    <!-- Subtitle -->
    <div class="col-start-2 justify-items-start">
      <p>{{ $t(subtitle) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    variant: {
      type: String,
      default: 'gray', // e.g. 'gray', 'blue', 'yellow', 'red', etc.
    },
  },
}
</script>
